import { Box, styled } from '@mui/material';
import { type FC, type ReactNode } from 'react';
import FlexBox from './flexbox/FlexBox';

interface LogoProps {
    logoWidth?: number;
    showText?: boolean;
    children?: ReactNode;
}

const LogoContainer = styled(FlexBox)(() => ({
    position: 'relative',
    alignItems: 'center',
}));

const Logo: FC<LogoProps> = ({
    logoWidth = 50,
    showText = true,
    children
}) => {
    return (
        <LogoContainer>
            <Box sx={{ position: 'relative' }}>
                <img src='/static/logo/logo_onestaff_new.png' alt='logo' width={logoWidth} />
            </Box>
            {showText && children}
        </LogoContainer>
    );
};

export default Logo;
